import React, { createContext, useCallback, useEffect, useRef, useState } from 'react';
import { getCurrencyExchange } from '../services/currenciesService';

export const CurrencyContext = createContext();

/** Clave de persistencia en localStorage. Misma convención que
 *  TimezoneProvider (`mirtomex.timezone`) para mantener nomenclatura. */
const STORAGE_KEY = 'mirtomex.currency';
const DEFAULT_CURRENCY = { symbol: 'MXN', exchange: 1 };

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState(DEFAULT_CURRENCY);
  // En la 1ª renderización ya intentaremos rehidratar desde localStorage;
  // este ref evita que el efecto se ejecute dos veces en StrictMode.
  const hydrated = useRef(false);

  // Hace el fetch del exchange si la moneda elegida no es MXN y persiste.
  // Si symbol es MXN o falla, cae al default sin tipo de cambio.
  const changeCurrency = useCallback(async (symbol) => {
    if (!symbol || symbol === 'MXN') {
      setCurrency(DEFAULT_CURRENCY);
      try {
        window.localStorage.setItem(STORAGE_KEY, 'MXN');
      } catch (_) {
        /* localStorage puede fallar en modo incógnito / Safari ITP */
      }
      return;
    }
    try {
      const { data } = await getCurrencyExchange(DEFAULT_CURRENCY.symbol, symbol);
      setCurrency({ symbol, exchange: data.data.value });
      try {
        window.localStorage.setItem(STORAGE_KEY, symbol);
      } catch (_) {
        /* idem */
      }
    } catch (error) {
      console.error('Error fetching currency exchange:', error);
    }
  }, []);

  // Hidratación al montar: si hay una moneda persistida distinta de la
  // por defecto, reaplicarla (dispara el fetch del exchange para EUR/USD).
  useEffect(() => {
    if (hydrated.current) return;
    hydrated.current = true;
    let stored = null;
    try {
      stored = window.localStorage.getItem(STORAGE_KEY);
    } catch (_) {
      /* sin acceso a localStorage → quedamos en default */
    }
    if (stored && stored !== 'MXN') changeCurrency(stored);
  }, [changeCurrency]);

  return <CurrencyContext.Provider value={{ currency, changeCurrency }}>{children}</CurrencyContext.Provider>;
};
